var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, forwardRef } from 'react';
import classNames from 'classnames';
import { Typography } from '../../../foundations/typography';
import useEffectSkipFirst from '../../../utils/useEffectSkipFirst';
import styles from './Tab.module.scss';
var TabComponent = function (_a, ref) {
    var _b;
    var _c;
    var _d = _a.active, active = _d === void 0 ? false : _d, _e = _a.index, index = _e === void 0 ? 0 : _e, label = _a.label, onClick = _a.onClick, onKeyDown = _a.onKeyDown, subComponent = _a.subComponent, _f = _a.theme, theme = _f === void 0 ? 'primary' : _f, rest = __rest(_a, ["active", "index", "label", "onClick", "onKeyDown", "subComponent", "theme"]);
    var localRef = useRef(null);
    var tabRef = (_c = ref) !== null && _c !== void 0 ? _c : localRef;
    useEffectSkipFirst(function () {
        if (active && tabRef.current) {
            tabRef.current.focus({ preventScroll: true });
        }
    });
    var className = classNames(styles.button, (_b = {},
        _b[styles.active] = active,
        _b[styles.secondary] = theme === 'secondary',
        _b));
    return (React.createElement(Typography, __assign({ "aria-controls": "tab-panel-".concat(index), "aria-selected": active, className: className, element: "button", id: "tab-".concat(index), noMargins: true, onClick: onClick, onKeyDown: onKeyDown, ref: tabRef, role: "tab", styleAs: "paragraphHeading", tabIndex: active ? undefined : -1, type: "button" }, rest),
        React.createElement("span", { className: styles.label }, label),
        !!subComponent && (React.createElement("span", { className: styles.subComponent, "data-testid": "tabSubComponent" }, subComponent))));
};
export var Tab = forwardRef(TabComponent);
//# sourceMappingURL=Tab.js.map